import React, { useEffect, useRef, useState } from 'react';

import TuneIcon from '@material-ui/icons/Tune';
import { useDispatch, useSelector } from 'react-redux';

import { closedTip } from '../../../store/actions';
import { ModalButton } from '../../ModalButton';
import { TipPopOut } from '../../TipPopOut';
import styles from '../SingleInputPage/SingleInputPage.module.scss';
import i18n from '../../../i18n';

type FilterButtonSectionProps = {
  toggleFilterMenu: () => void;
};

export const FilterButtonSection = ({
  toggleFilterMenu,
}: FilterButtonSectionProps) => {
  const dispatch = useDispatch();
  const shouldShowFilterTip = useSelector<DefaultRootState>(
    (store) => store.state.tips.mapFilter,
  );
  const [showFilterTip, setShowFilterTip] = useState(false);
  const disableShowFilterTipTimeout = useRef<NodeJS.Timeout | null>(null);

  const handleCloseFilterTip = () => {
    toggleFilterMenu();
    if (disableShowFilterTipTimeout.current) {
      clearTimeout(disableShowFilterTipTimeout.current);
    }
    setShowFilterTip(false);
    if (shouldShowFilterTip) {
      dispatch(closedTip('mapFilter'));
    }
  };

  useEffect(() => {
    if (shouldShowFilterTip) {
      disableShowFilterTipTimeout.current = setTimeout(
        () => setShowFilterTip(true),
        2000,
      );
    }
  }, [shouldShowFilterTip]);

  return (
    <div className={styles.filterButton}>
      <ModalButton onClick={handleCloseFilterTip}>
        <TuneIcon fontSize="large" />
      </ModalButton>
      <div style={{ position: 'absolute', top: 90, right: 50 }}>
        <TipPopOut
          text={i18n.t('mapPage.seeFilters') as unknown as string}
          visible={showFilterTip}
          onClose={handleCloseFilterTip}
        />
      </div>
    </div>
  );
};
